<template>
    <div class="footer">
        <div class="footer-inner">
            <div class="footer-main">
                <div class="footer-inner-link">
                    <a href="http://www.meizu.com/about.html" target="_blank" title="关于魅族" v-show="nowLang === '简体中文'">关于魅族</a>
                    <a href="https://www.meizu.com/en/about.html" target="_blank" title="about us" v-show="nowLang === 'English'">About us</a>
				    <div class="foot-line" ></div>
                    <a href="http://www.meizu.com/contact.html" target="_blank" title="联系我们" v-show="nowLang === '简体中文'">联系我们</a>
                    <a title="Contact us" target="_blank" href="https://www.meizu.com/en/contact.html " v-show="nowLang === 'English'">Contact us</a>
                    <div class="foot-line" ></div>
                    <a href="https://www.meizu.com/legal.html" target="_blank" title="法律声明" v-show="nowLang === '简体中文'">法律声明</a>
                    <a title="Legal Statment" target="_blank" href="https://www.meizu.com/en/legal.html" v-show="nowLang === 'English'">Legal Statement</a>
                    <div class="foot-line" ></div>
                    <a :href="helpcenterLink" target="_blank" title="帮助中心" v-show="nowLang === '简体中文'">帮助中心</a>
                    <div class="foot-line"  v-show="nowLang === '简体中文'"></div>
                    <div href="javascript:void(0);" id="globalName" class="footer-language" title="简体中文" @mouseover="showLangMenu" @mouseout="hideLangMenu">
                        {{nowLang}}&nbsp;&nbsp;&nbsp;
                        <div id="globalContainer" class="footer-language_menu" v-show="langShow">
                            <a href="javascript:void(0)" id="i18n-link" class="ClobalItem" @click="exchangeLang">{{langMenuItem}}</a>
                        </div>
                    </div>
                </div>
                <div class="footer-inner-service" v-show="nowLang === '简体中文'">
                    <span class="service-label">客服热线</span>
                    <span class="service-num">400-788-3333</span>
                    <a id='service-online' class='service-online' title="在线客服" @click="openOnline">在线客服</a>
                </div>
                <div class="mz_footer-service" v-show="nowLang === 'English'">
                    <a href="mailto:mzcs@meizu.com">
                    <span class="mz_service-label">Customer Service: mzcs@meizu.com</span>
                    </a>    
                </div>
                <div class='footer-outerLink' v-show="nowLang === '简体中文'">
                    <div class="wechat-qrcode" v-show="show"></div>
                    <a class='footer-sinaMblog' href="http://weibo.com/meizumobile" target="_blank"><i class='icon'></i></a>
                    <a id='footer-weChat' class='footer-weChat' target="_blank" @mouseover="showQrcode" @mouseout="hideQrcode"><i class='icon'></i></a>
                    <a class='footer-qzone' href="http://user.qzone.qq.com/2762957059" target="_blank"><i class='icon'></i></a>
                </div>
                <div class="mz_footer-outerLink" v-show="nowLang === 'English'">
                    <a class="mz_footer-facebook" href="https://www.facebook.com/MeizuIndiaOfficial" target="_blank"><i class="mz_i_icon"></i></a>
                    <a class="mz_footer-twitter" href="https://twitter.com/Meizu_India" target="_blank"><i class="mz_i_icon"></i></a>
                    <a class="mz_footer-googleplus" href="https://plus.google.com/u/0/b/113858313108002162708/113858313108002162708/posts " target="_blank"><i class="mz_i_icon"></i></a>
                    <a class="mz_footer-linkin" href="https://www.linkedin.com/company/meizu" target="_blank"><i class="mz_i_icon"></i></a>        
                </div>
            </div>
            <div class="clear"></div>
            <div class="footer-copyright">
                <div class="copyrightInner">
                    <span>©2023 珠海星纪魅族信息技术有限公司</span>
                    <a target="_blank"  href="https://beian.miit.gov.cn/" style="margin-left:6px" class='linkAGray' v-show="nowLang === '简体中文'">备案号：粤ICP备13003602号-12</a>
                    <a href="https://r2.mzres.com/business/account/images/business-license.jpg" class='linkAGray' target="_blank" v-show="nowLang === '简体中文'">经营许可证编号：合字B2-20170010</a>
                    <a target="_blank" href="https://r2.mzres.com/business/account/images/business-certificate.jpg" hidefocus="true" class="linkAGray" v-show="nowLang === '简体中文'">营业执照</a>
                    <a target="_blank" href="https://xj-platform.flyme.com/fms/policy/212d5a3b02c05f22861eb081968e9e9c_2.html" hidefocus="true" class="linkAGray" v-show="nowLang === '简体中文'">服务协议</a>
                    <a target="_blank" href="https://xj-platform.flyme.com/fms/policy/ead4f669c162571295da8b5a93ce19c9_2.html" hidefocus="true" class="linkAGray" v-show="nowLang === '简体中文'">隐私政策</a>
                    <a target="_blank" href="https://xj-platform.flyme.com/fms/policy/d42aab0e9bf35222b9a07ea3cb792e69_2.html" hidefocus="true" class="linkAGray" v-show="nowLang === '简体中文'">儿童个人信息保护规则</a>
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049102496076" class="gov" v-show="nowLang === '简体中文'">粤公网安备 44049102496076号</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { IS_INTERNATIONAL } from '@/assets/const.js'
export default {
    props: {
        nowLang: {
            type: String,
            default: 'English'
        },
        langMenuItem: {
            type: String,
            default: 'English'
        }
    },
    data() {
        return {
            show: false,
            langShow: false,
        }
    },
    computed: {
      helpcenterLink() {
        const host = !IS_INTERNATIONAL ?  'https://account.in.meizu.com' : 'https://account.flyme.cn'
        return `${host}/user/helpcenter`
      }
    },
    methods: {
        showQrcode() {
            this.show = true;
        },
        hideQrcode() {
            this.show = false;
        },
        openOnline() {
            window.open('http://url.meizu.com/ols_Fyun',
    			'_blank','height=575,width=1150,fullscreen=3,top=200,left=200,status=yes,toolbar=no,menubar=no,resizable=no,scrollbars=no,location=no,titlebar=no,fullscreen=no');
        },
        showLangMenu() {
            this.langShow = true;
        },
        hideLangMenu() {
            this.langShow = false;
        },
        exchangeLang() {
            this.$emit('translate');
        }
    }
}
</script>

<style lang="scss">
$internationalcdnhost: 'https://uc-res.in.meizu.com';
$cdnhost: 'https://uc-res.mzres.com';

html[data-env=international] .footer {
   .icon {
      background-image: url($internationalcdnhost + '/resources/uc/web/member/static/forgetPassword/base.png');
   }
   .footer-language{
      background-image: url($internationalcdnhost + '/resources/uc/web/member/static/forgetPassword/base.png') ;
   }
   .wechat-qrcode {
      background-image: url($internationalcdnhost + '/resources/uc/web/member/static/forgetPassword/weixin.png');
    }
    .gov{
      background-image: url($internationalcdnhost + '/resources/uc/web/member/static/forgetPassword/ghs.png'); 
    }
}
.footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 130px;
    border-top: solid 1px #E5E6E7;
    background-color: #fff;
    color: black;
    .icon {
      background: url($cdnhost + '/resources/uc/web/member/static/forgetPassword/base.png');
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .footer-inner {
        width: 1200px;
        margin: 24px auto 30px;
        .footer-main {
            height: 50px;
            line-height: 50px;
            a {
                color: #515151;
                text-decoration: none;
                font-size: 14px;
                &:link {
                    color: black;
                }
            }
            .footer-inner-link {
                float: left;
                font-size: 14px;
                .foot-line {
                    background-color: #888;
                    margin: 0px 5px;
                    width: 1px;
                    height: 10px;
                    display: inline-block;
                }
                .footer-language {
                    display: inline;
                    position: relative;
                    overflow: hidden;
                    cursor: default;
                    background-image: url($cdnhost + '/resources/uc/web/member/static/forgetPassword/base.png') ;
                    background-position: -80px -150px ;
                    background-repeat: no-repeat;
                    .footer-language_menu {
                        -moz-box-shadow: 0px 0px 10px #E1E4E8;
                        -webkit-box-shadow: 0px 0px 10px #E1E4E8;
                        box-shadow: 0px 0px 10px #E1E4E8;
                        -moz-border-radius: 2px;
                        -webkit-border-radius: 2px;
                        -webkit-border-radius: 2px;
                        border-radius: 2px;
                        background-color: #FEFEFE;
                        position: absolute;
                        border: solid 1px #E1E4E8;
                        overflow: hidden;
                        left: -8px !important;
                        bottom: 16px;
                        width: 77px;
                        /* height: 80px; */
                        a {
                            display: block;
                            height: 40px;   
                            line-height: 40px;
                            margin: 0px auto;
                            text-decoration: none;
                            border-bottom: solid 1px #E4E7E9;
                            font-size: 14px;
                            color: #000000;
                            text-align: left;
                            padding-left: 10px;
                            outline: none;
                        }
                    }
                }
            }
            .footer-inner-service {
                float: left;
                margin-left: 36px;
                font-size: 14px;
                .service-label {
                    margin-right: 10px;
                }
                .service-num {
                    margin-right: 20px;
                }
                .service-online {
                    display: inline-block;
                    height: 20px;
                    line-height: 18px;
                    width: 64px;
                    color: white;
                    background-color: #32a5e7;
                    border-radius: 2px;
                    -webkit-border-radius: 2px;
                    -moz-border-radius: 2px;
                    text-align: center;
                    cursor: pointer;
                }
            }
            .mz_footer-service {
                float: left;
                margin-left: 36px;
            }
            .footer-outerLink {
                position: relative;
                float: right;
                padding-top: 9px;
                a {
                    cursor: pointer;
                    margin-left: 10px;
                    display: inline-block;
                    overflow: hidden;
                    width: 32px;
                    height: 32px;
                }
                .footer-sinaMblog {
                    i {
                        background-position: -218px -91px;
                        display: inline-block;
                    }
                    &:hover {
                        i {
                            background-position: -218px -137px;
                        }
                    }
                }
                .footer-weChat {
                    i {
                        background-position: -302px -91px;
                        display: inline-block;
                    }
                    &:hover {
                        i {
                            background-position: -302px -137px;;
                        }
                    }
                }
                .footer-qzone {
                    i {
                        background-position: -344px -91px;
                        display: inline-block;
                    }
                    &:hover {
                        i {
                            background-position: -344px -137px;
                        }
                    }
                }
            }
            .mz_footer-outerLink {
                position: relative;
                float: right;
                padding-top: 9px;
                a {
                    margin-left: 10px;
                    display: inline-block;
                    overflow: hidden;
                    width: 32px;
                    height: 32px;
                    .mz_i_icon {
                        display: inline-block;
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        background: url(data:image/png;base64,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) no-repeat;
                    }
                    &.mz_footer-facebook {
                        i {
                            background-position: 0 0;
                            &:hover {
                                background-position: 0 -45px;
                            }
                        }
                    }
                    &.mz_footer-twitter {
                        i {
                            background-position: -42px 0;
                            &:hover {
                                background-position: -42px -45px;
                            }
                        }
                        
                    }
                    &.mz_footer-googleplus {
                        i {
                            background-position: -168px 0;
                            &:hover {
                                background-position: -168px -45px;
                            }
                        }
                    }
                    &.mz_footer-linkin {
                        i {
                             background-position: -84px 0;
                             &:hover {
                                background-position: -84px -45px;
                            }
                        }
                    }
                }
            }
        }
        .clear {
            content: "";
            clear: both;
            display: block;
            height: 0;
            overflow: hidden;
        }
        .footer-copyright {
            width: 100%;
            .copyrightInner {
                width: 1200px;
                margin: 0px auto;
                span {
                    font-size: 12px;
                    color: #7f7f7f;
                    float: left;
                }
                a {
                    white-space: nowrap;
                    float: left;
                    color: #7f7f7f;
                    margin-left: 6px;
                    font-size: 12px;
                    &.linkAGray{
                        color: #7f7f7f;
                    }
                }
            }
        }
    }
    .wechat-qrcode {
        position: absolute;
        z-index: 1000;
        width: 310px;
        height: 270px;
        left: -82px;
        top: -250px;
        background-image: url($cdnhost + '/resources/uc/web/member/static/forgetPassword/weixin.png');
        background-repeat: no-repeat;
    }
    .gov{
      background-image: url($cdnhost + '/resources/uc/web/member/static/forgetPassword/ghs.png'); 
      background-size: 15px 14px; 
      padding-left: 18px;
      background-position-y: center;
      background-repeat: no-repeat;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue